import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import SEO from './SEO';

const PageContainer = styled.div`
  min-height: 100vh;
  padding: 8rem 0 4rem;
  background-color: var(--background-color);
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2.5rem;
  color: var(--text-color);

  span {
    color: var(--primary-color);
  }
`;

const Section = styled.section`
  background: var(--card-background);
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
`;

const SectionTitle = styled.h2`
  font-size: 1.4rem;
  margin-bottom: 1rem;
  color: var(--primary-color);
`;

const Text = styled.p`
  color: var(--text-color);
  line-height: 1.7;
  margin: 0 0 0.5rem;
`;

const Impressum: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <SEO
        title="Impressum"
        description="Impressum der Byte Forge UG (haftungsbeschränkt): Anschrift, Vertretungsberechtigte und rechtliche Angaben."
        path="/impressum"
      />
      <Container>
        <PageTitle>{t('imprint.title_part1')} <span>{t('imprint.title_part2')}</span></PageTitle>

        <Section>
          <SectionTitle>{t('imprint.company.heading')}</SectionTitle>
          <Text>Byte Forge UG (haftungsbeschränkt)</Text>
          <Text>Alte Gärtnerei 4</Text>
          <Text>04425 Taucha</Text>
          <Text>Deutschland</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.representative.heading')}</SectionTitle>
          <Text>Thomas Gross</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.contact.heading')}</SectionTitle>
          <Text>{t('imprint.contact.email_label')}: thomas.gross@byte-forge.it</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.register.heading')}</SectionTitle>
          <Text>{t('imprint.register.court_label')}: Amtsgericht Leipzig</Text>
          <Text>{t('imprint.register.number_label')}: HRB 43641</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.tax.heading')}</SectionTitle>
          <Text>{t('imprint.tax.vat_label')}: DE451666276</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.responsible.heading')}</SectionTitle>
          <Text>{t('imprint.responsible.text')}</Text>
          <Text>Byte Forge UG (haftungsbeschränkt)</Text>
          <Text>Alte Gärtnerei 4, 04425 Taucha</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.dispute.heading')}</SectionTitle>
          <Text>{t('imprint.dispute.text')}</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.liability_content.heading')}</SectionTitle>
          <Text>{t('imprint.liability_content.text')}</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.liability_links.heading')}</SectionTitle>
          <Text>{t('imprint.liability_links.text')}</Text>
        </Section>

        <Section>
          <SectionTitle>{t('imprint.copyright.heading')}</SectionTitle>
          <Text>{t('imprint.copyright.text')}</Text>
        </Section>
      </Container>
    </PageContainer>
  );
};

export default Impressum;
